var date = {
  "abbr_day_names": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  "abbr_month_names": [null, "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  "day_names": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  "formats": {
    "default": "%d/%m/%Y",
    "long": "%B %d, %Y",
    "short": "%d %b",
    "day_long": "%A %e",
    "datepicker2": "%b %e, %Y",
    "short_day": "%a, %b %e",
    "month_year": "%b %Y",
    "long_dow": "%a, %B %d, %Y",
    "long_month_only": "%B",
    "long_year_only": "%Y",
    "long_month_year": "%B %Y",
    "myenlighten_month": "%m/%Y",
    "graph": {
      "long": "%a %b %e %Y",
      "x_axis": {
        "day": "%b %e",
        "week": "%b %e"
      }
    },
    "jquery": {
      "datepicker": "d/m/y",
      "datepicker2": "d M, yy",
      "power_playback": "ddd MMM d, yyyy hh:mm tt",
      "myenlighten": "dd/mm/yyyy",
      "datejs_formatter": "dd/M/yyyy",
      "myenlighten_month": "mm/yyyy",
      "myenlighten_overview": "D, M d, yyyy",
      "datejs_month_formatter": "M/yyyy"
    },
    "js": {
      "short_month": "%b",
      "short_day_year": "%a, %b %e, %Y",
      "short_month_day": "%B&nbsp;%d,&nbsp;%Y",
      "short_month_day_time": "%B %d, %Y – %-I:%M",
      "short_dow_month_day_time": "%a, %B %d, %Y – %-I:%M",
      "month_day_year_time": "%B %d, %Y %-I:%M %p"
    }
  },
  "month_names": [null, "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  "order": ["year", "month", "day"],
  "range": {
    "presets": {
      "today": "Today",
      "last7Days": "Past 7 Days",
      "monthToDate": "Month to Date",
      "yearToDate": "Year to Date"
    }
  }
};
module.exports = date;